import * as API from '../'
export default {
  // 机构用户列表
  userznfList: params => {
    return API.POST(ACCOUNTSERVER+'/api/v1/user/znf/web/list',params)
  },
  // 新增机构用户
  registerznfUser: params => {
    return API.POST(ACCOUNTSERVER+'/api/v1/register/znf/web/user',params)
  },
  //编辑用户
  updateznfBase: params => {
    return API.POST(ACCOUNTSERVER+'/api/v1/user/update/znf/web/base',params)
  },
  //删除用户
  userznfDelete: params => {
    return API.POST(ACCOUNTSERVER+'/api/v1/user/znf/web/delete',params)
  },
  // 重置默认密码
  userupdatePassword: params => {
    return API.POST(ACCOUNTSERVER+'/api/v1/user/update/password',params)
  },
  //详情
  userDetail: params => {
    return API.POST(ACCOUNTSERVER+'/api/v1/user/detail/id',params)
  },
  //获取机构名
  deptuserList: params => {
    return API.POST(SYSSERVER+'/api/v1/enterprise/dept/user/list',params)
  },
  // 服务组织
  getZzlxList:param=>{
    return API.POST(SYSSERVER+'/api/v1/dic/enterprise/type/list',param);
  },
  // 主体类型字典
  dicListDic:param=>{
    return API.POST(SYSSERVER+'/api/v1/dic/app/list',param);
  },
  // 新增区划
  enterpriseSave:param=>{
    return API.POST(SYSSERVER+'/api/v3/enterprise/sample/save',param);
  },
  //平台用户列表
  usermanageList:param=>{
    return API.POST(ACCOUNTSERVER+'/api/v1/user/manage/list',param);
  },
  //查询机构列表
  enterprDeptisList:param=>{
    return API.POST(SYSSERVER+'/api/v2/enterprise/dept/user/list',param);
  },
  //保存机构
  enterpriseDeptSave:param=>{
    return API.POST(SYSSERVER+'/api/v1/enterprise/dept/save',param);
  },
  // 机构详情
  enterprisedeptDetail:param=>{
    return API.POST(SYSSERVER+'/api/v1/enterprise/dept/detail',param);
  },
  // 更新机构
  enterpriseDeptUpdate:param=>{
    return API.POST(SYSSERVER+'/api/v1/enterprise/dept/update',param);
  },
  // 删除机构
  enterpriseDeptDelete:param=>{
    return API.POST(SYSSERVER+'/api/v1/enterprise/dept/delete',param);
  }, 
//获取职能分组及人员信息
usermanageQueryGroup:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/queryGroup',param);
},
// 新增职能分组
usermanageAddGroup:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/addGroup',param);
},
// 删除职能分组
usermanageRemoveGroup:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/removeGroup',param);
},
// 修改职能分组(合并组内人员)
usermanageUpdateGroup:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/updateGroup',param);
},
// 删除职能组用户
usermanageRemoveGroupUser:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/removeGroupUser',param);
},
// 获取公司下的机构及用户
usermanageQueryCompany:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/queryCompany',param);
},
// 新增用户
usermanageAddUser:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/addUser',param);
},
// 用户详情接口
usermanageQueryUserByPhone:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/queryUserByPhone',param);
},
// 职能分组详情
usermanageQueryGroupDetails:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/queryGroupDetails',param);
},
// 设置用户为主管
usermanageSetUserManager:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/setUserManager',param);
},
// 恢复默认密码
usermanageResetPassword:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/resetPassword',param);
},
// 修改用户信息
usermanageUpdateUser:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/updateUser',param);
},
//删除机构
usermanageRemoveOrganization:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/removeOrganization',param);
},
//删除机构用户
usermanageRemoveOrganizationUser:param=>{
  return API.POST(SYSSERVER+'/api/v2/usermanage/removeOrganizationUser',param);
},

}


// WEBPACK FOOTER //
// ./src/api/organizeManagement/api_organizationUsre.js